import { useEffect, useState } from "react";
import { TypeDialogMessageEnum } from "../model/Enums/TypeDialogMessageEnum";

import ButtonStyles from "../styles/components/ButtonStyles";
import DialogStyles from "../styles/components/DialogStyles";
import Dialog from "./Dialog";
import { InformationModalIcon, SuccessModalIcon } from "./Icons";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

interface DialogMessageListParams {
    show: boolean;
    type: TypeDialogMessageEnum;
    title: string;
    content: string[];
    textButton?: string;
    textButtonClose?: string;
    onClose?: any;
}

function DialogMessageList({
    show,
    type,
    title,
    content,
    textButton = "OK",
    textButtonClose,
    onClose,
}: DialogMessageListParams) {
    const [icon, setIcon] = useState<any>(null);

    const handleClose = (params?: any) => {
        onClose({
            confirmButton: Boolean(params?.confirmButton),
            cancelButton: Boolean(params?.cancelButton),
            closelButton: Boolean(
                !params?.confirmButton && !params?.cancelButton
            ),
        });
    };

    useEffect(() => {
        if (!show) return;

        switch (type) {
            case TypeDialogMessageEnum.Success:
                setIcon(<SuccessModalIcon />);
                break;
            case TypeDialogMessageEnum.Error:
                setIcon(<InformationModalIcon />);
                break;
            case TypeDialogMessageEnum.Warning:
                setIcon(<InformationModalIcon style={{ fill: "#a16000" }} />);
                break;
            default:
                setIcon(null);
                break;
        }
    }, [show]);

    return (
        <Dialog
            openModal={show}
            onHide={handleClose}
            size="width-300"
            modalIcon={icon}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                {title}
            </StyledModalTitle>
            {content.map((item: any) => (
                <StyledModalText
                    style={{ marginTop: "24px", marginBottom: "24px" }}
                >
                    {item}
                </StyledModalText>
            ))}
            <StyledContainerButton>
                <BtnPrimary
                    onClick={() => {
                        handleClose({
                            confirmButton: true,
                        });
                    }}
                >
                    {textButton}
                </BtnPrimary>
            </StyledContainerButton>
            {textButtonClose && (
                <StyledContainerButton>
                    <DefaultButtonLink
                        onClick={() => {
                            handleClose({
                                cancelButton: true,
                            });
                        }}
                    >
                        {textButtonClose}
                    </DefaultButtonLink>
                </StyledContainerButton>
            )}
        </Dialog>
    );
}

export default DialogMessageList;
